<style scoped>

</style>
<template>
	<div>
		<Row class="expand-row">
			<Col span="4">
			<span class="expand-key">充电电费: </span>
			<span class="expand-value">{{ row.ElecCost }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">充电服务费: </span>
			<span class="expand-value">{{ row.ServiceCost }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">充电电量: </span>
			<span class="expand-value">{{ row.ChargeKwh }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">起始SOC: </span>
			<span class="expand-value">{{ row.BeginSoc }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">结束SOC: </span>
			<span class="expand-value">{{ row.EndSoc }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">充电时长: </span>
			<span class="expand-value">{{ row.ChargeDuration }}</span>
			</Col>
		</Row>
		<Row>
			<Col span="4">
			<span class="expand-key">充电前电表示值: </span>
			<span class="expand-value">{{ row.MeterBeginReading }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">充电后电表示值: </span>
			<span class="expand-value">{{ row.MeterEndReading }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">退款金额: </span>
			<span class="expand-value">{{ row.RefundAmount }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">退款状态: </span>
			<span class="expand-value">{{ row.RefundStatus }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">退款时间: </span>
			<span class="expand-value">{{ row.RefundTime }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">停止原因: </span>
			<span class="expand-value">{{ row.TerminateReason }}</span>
			</Col>
		</Row>
		<Row>
			<Col span="4">
			<span class="expand-key">充电卡号: </span>
			<span class="expand-value">{{ row.CardNo }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">会员手机: </span>
			<span class="expand-value">{{ row.MemberPhone }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">会员名称: </span>
			<span class="expand-value">{{ row.MemberName }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">设备编号: </span>
			<span class="expand-value">{{ row.EquipmentNo }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">枪编号: </span>
			<span class="expand-value">{{ row.ConnectorNo }}</span>
			</Col>
			<Col span="4">
			<span class="expand-key">{{ this.$t('StationName') }}: </span>
			<span class="expand-value">{{ row.StationName }}</span>
			</Col>
		</Row>
	</div>
</template>
<script>
	export default {
		props: {
			row: Object
		}
	};
</script>
